import { useState, useRef } from "react";

/**
 * 对话页面状态复用 Hook
 * 封装每个对话页面必需的：消息列表、加载态、请求控制器、会话 ID、思考计时器、滚动容器 ref
 * 
 * @returns {{ messages, setMessages, isLoading, setIsLoading, abortRef, sessionIdRef, thinkingTimerRef, containerRef }}
 */
export function usePageState() {
    const [messages, setMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const abortRef = useRef(null);
    const sessionIdRef = useRef("");
    const thinkingTimerRef = useRef(null);
    const containerRef = useRef(null);

    return {
        messages,
        setMessages,
        isLoading,
        setIsLoading,
        abortRef,
        sessionIdRef,
        thinkingTimerRef,
        containerRef,
    };
}
